import { SelectItem } from '../ui/select';

/** Las opciones del desplegable «Lugar del quirófano», de Configuración.
 *  Sin ninguno dado de alta, una línea que dice dónde se ponen. */
export default function OpcionesLugar({ lugares }) {
  if (!lugares.length) {
    return (
      <SelectItem value="__sin_lugares__" disabled>
        Sin lugares: se añaden en Configuración
      </SelectItem>
    );
  }
  return lugares.map((l) => <SelectItem key={l} value={l}>{l}</SelectItem>);
}
